import { create } from 'qrcode';

// No remote QR service: destination/payment data stays in the browser.
export function generatePaymentQRCodeSVG(text: string, size = 190): string {
  if (!text || text.length > 1024) throw new Error('Invalid payment QR payload');
  const qr = create(text, {errorCorrectionLevel:'M'});
  const side = qr.modules.size + 8;
  const pixels = Math.min(1024, Math.max(64, Math.round(size)));
  let cells = '';
  for (let row = 0; row < qr.modules.size; row++) {
    for (let col = 0; col < qr.modules.size; col++) {
      if (qr.modules.get(row,col)) cells += `<rect x="${col+4}" y="${row+4}" width="1" height="1"/>`;
    }
  }
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${pixels}" height="${pixels}" viewBox="0 0 ${side} ${side}" shape-rendering="crispEdges" role="img" aria-label="Payment QR code"><rect width="${side}" height="${side}" fill="white"/><g fill="black">${cells}</g></svg>`;
}
